import React, { useEffect, useRef, useState } from 'react';
import '../component.scss';
import SearchField from './SearchField';
import CounterWidget from './CounterWidget';

const PeoplesWidget = ({
  adults,
  kids,
  ages = [],
  label,
  onChoose,
  cssClass = '',
}) => {

  const [isWidgetOpen, setIsWidgetOpen] = useState('');

  const [adult, setAdult] = useState(parseInt(adults));
  const [child, setChild] = useState(parseInt(kids));
  const [agesList, setAgesList] = useState(ages.map((age) => parseInt(age)));
  const ADULT_MIN = 1;
  const ADULT_MAX = 5;
  const CHILD_MAX = 3;
  const CHILD_MIN = 0;

  const peoplesWidgetRef = useRef(null);

  useEffect(() => {
    setIsWidgetOpen(false)
  }, [])

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        peoplesWidgetRef.current &&
        !peoplesWidgetRef.current.contains(e.target)
      ) {
        setIsWidgetOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {})

  const handleReset = () => {
    onChoose({ adults: 2, kids: 0, ages: [] });
    setChild(0);
    setAdult(2);
    setAgesList([]);
    setIsWidgetOpen(false);
  };

  const onSetChild = (value) => {
    if (value > child) {
      setAgesList((prevAges) => [...prevAges, 6]);
      setChild(value);
    } else if (value < child) {
      setAgesList((prevAges) => prevAges.slice(0, -1));
      setChild(value);
    }
  };

  const onSetAdult = (value) => {
    setAdult(value);
  };

  function handleWidgetOpening(e) {
    e.preventDefault();
    setIsWidgetOpen(true);
  }

  function handleSubmit(e) {
    e.preventDefault();
    onChoose({ adults: adult, kids: child, ages: agesList });
    setIsWidgetOpen(false);
  }

  const title = `${adults} взр ${!!kids ? `+ ${kids} реб` : ``}`;
  const wasChanged = adult !== 2 || child !== 0;

  return (
    <div ref={peoplesWidgetRef} className="search-widget peopleAmount">
      <div
        onClick={(e) => handleWidgetOpening(e)}
        className={`search-field ${wasChanged}`}
      >
        <SearchField
          cssClass={cssClass}
          label={label}
          placeholder={true}
          title={title}
          value={adults}
        />
      </div>
      {isWidgetOpen ? (
        <div className="popup-list">
          <div className="filterbar">
            <button className="btn btn_submit" onClick={handleSubmit}>
              Готово
            </button>
            <button className="btn btn_reset" onClick={handleReset}>
              Сбросить
            </button>
          </div>
          <div className="tourists-amount__container popup-body fixed">
            <div className="tourists-amount__adults">
              <div className="tourists-counter">
                <CounterWidget
                  header={'Взрослые'}
                  min={ADULT_MIN}
                  max={ADULT_MAX}
                  onSet={onSetAdult}
                  value={adult}
                />
              </div>
            </div>
            <div className="tourists-amount__kids">
              <div className="tourists-counter">
                <CounterWidget
                  header={'Дети'}
                  max={CHILD_MAX}
                  min={CHILD_MIN}
                  onSet={onSetChild}
                  value={child}
                />
              </div>
              {agesList.map((age, idx) => {
                return (
                  <div className="tourists-counter" key={idx}>
                    <CounterWidget
                      idx={idx}
                      header={`Возраст ${idx + 1} ребенка`}
                      max={16}
                      min={1}
                      onSet={(value) => {
                        setAgesList((prevAges) => {
                          const newAges = [...prevAges];
                          newAges[idx] = value;
                          return newAges;
                        });
                      }}
                      value={age}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default PeoplesWidget;
